export enum DoorOperationType {
  BYPASS = "BYPASS",
  BI_FOLD = "BI_FOLD",
  DOUBLE_BI_FOLD = "DOUBLE_BI_FOLD",
  DOUBLE = "DOUBLE",
  DOUBLE_FIXED_PANEL = "DOUBLE_FIXED_PANEL",
  CLOSET = "CLOSET",
  ATTIC = "ATTIC",
  OPEN = "OPEN",
  ARC = "ARC",
  PORTICO = "PORTICO",
  WALL_MOUNTED = "WALL_MOUNTED",
  GARAGE_SINGLE = "GARAGE_SINGLE",
  GARAGE_DOUBLE = "GARAGE_DOUBLE",
  FIREPLACE = "FIREPLACE",
  POCKET = "POCKET",
}

export const doorOperationTypeIsOpen: {
  [key in DoorOperationType]?: boolean;
} = {
  [DoorOperationType.OPEN]: true,
  [DoorOperationType.ARC]: true,
  [DoorOperationType.PORTICO]: true,
};
